export default function () {
  const widgetName = 'multimanagedwidget';
  const widgetOpts = multimanagedwidgetOpts;
  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: ''
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      $(`#${widgetName} .card-widget-item`).each(function (i, item) {
        if (data.items[i].DateRange) {
          var rawDate = data.items[i].DateRange.slice(0, 24);
          $(this).prepend(`
            <div class="card-widget-date">
              <span>${rawDate}</span>
              
            </div>
          `);
        }
      });
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'],
    // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: ''
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false,
    textOverImage: false
  });

}